import classNames from 'classnames'
import { type Nil, type User, Utils } from '@pbt/pbt-ui-components'

import MetadataList from '~/components/common/MetadataList'
import { ClientPreferencesChip } from '~/components/dashboard/clients/preferences/ClientPreferencesChip'
import useGetPreferredContactMethod from '~/hooks/useGetPreferredContactMethod'
import type { TimetableEvent } from '~/types'

import styles from '~/components/dashboard/soapV2/summary/patient-details/PatientDetailsHeader.module.scss'

const ClientInfo = ({
  appointment,
  hasActionsSlot,
  client,
}: {
  appointment?: TimetableEvent | Nil
  client: User | Nil
  hasActionsSlot: boolean
}) => {
  const clientName = Utils.getPersonString(client)
  const preferredContactMethod = useGetPreferredContactMethod({
    client,
    phoneOnly: true,
  })

  return (
    <div className={styles.clientInfo}>
      <ClientPreferencesChip
        isDisplayWidgetChirp
        appointment={appointment}
        className={styles.preferencesChip}
        clientId={client?.id}
      />
      <MetadataList
        isTruncated={hasActionsSlot}
        items={[
          {
            value: client?.id ? (
              <a
                className={classNames(styles.plainLink)}
                href={`/client/${client.id}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                {clientName}
              </a>
            ) : (
              Utils.getPersonString(client)
            ),
          },
          { value: preferredContactMethod.value || '' },
        ]}
      />
    </div>
  )
}

export default ClientInfo
